import "core-js/modules/es.symbol";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import React from 'react';
import { compose, withHandlers } from 'recompose';
import Translatable from '../translatable/Translatable';
var withClickHandler = withHandlers({
  onClick: function onClick() {
    return function (event) {
      event.stopPropagation();
    };
  }
});

var ChildWindowContent = function ChildWindowContent(_ref) {
  var addAdaBoundaries = _ref.addAdaBoundaries,
      content = _ref.content,
      modalRef = _ref.modalRef,
      onClick = _ref.onClick,
      keepProps = _objectWithoutProperties(_ref, ["addAdaBoundaries", "content", "modalRef", "onClick"]);

  return /*#__PURE__*/React.createElement("div", _extends({}, keepProps, {
    ref: modalRef,
    onClick: onClick,
    "data-testid": "childWindowContent"
  }), addAdaBoundaries && /*#__PURE__*/React.createElement(Translatable, {
    id: "global.dialog.begin",
    className: "visuallyHidden"
  }), content, addAdaBoundaries && /*#__PURE__*/React.createElement(Translatable, {
    id: "global.dialog.end",
    className: "visuallyHidden"
  }));
};

export default /*#__PURE__*/React.memo(compose(withClickHandler)(ChildWindowContent));